import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import type { GamerSection } from '../../../../shared/types/navigation'
import { getUrlForSidebarSection } from '../../../../shared/utils/sidebarNavigation'

/** Opens the page of the stop on screen, once each time the tour moves to another stop. */
export const usePlatformTourNavigation = (section: GamerSection | undefined) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (!section) return

    const url = getUrlForSidebarSection(section)
    if (pathname !== url) navigate(url)
    // Only a new stop navigates; following every location change would undo the browser's back button.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section])
}
